interface SessionDetailsInfoProps {
  title: string;
  time: string;
  borderColorVariant?: 'aqua' | 'orange' | 'red';
  onClick?: () => void;
  /** Optional trailing content (e.g. a participant/attendance summary). */
  trailing?: React.ReactNode;
}

export const SessionDetailsInfo = ({
  title,
  time,
  borderColorVariant: variant = 'aqua',
  onClick,
  trailing,
}: SessionDetailsInfoProps) => {
  const isClickable = Boolean(onClick);
  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (!onClick) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div
      className={`session-details-info w-full py-1.5 md:grid md:grid-cols-[minmax(0,5fr)_minmax(130px,4fr)_minmax(110px,3fr)] md:items-center md:gap-4 border-${variant}${isClickable ? ' cursor-pointer hover:underline' : ''}`}
      onClick={onClick}
      onKeyDown={isClickable ? handleKeyDown : undefined}
      role={isClickable ? 'button' : undefined}
      tabIndex={isClickable ? 0 : undefined}
    >
      <p className="line-clamp-1">{title}</p>
      <p className="text-grey-30 dark:text-grey-70 line-clamp-1 pl-5 text-sm md:pl-0">
        {time}
      </p>
      {trailing ? (
        <div className="mt-0.5 pl-5 md:mt-0 md:pl-0 md:justify-self-end">{trailing}</div>
      ) : null}
    </div>
  );
};
